import { createObserve, dom, common } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/pr-oad';

const { isFunction } = common;

const observerObj = {};

const REACH_BOTTOM = 'b_waimai_5b6jsnaq_mv'; // 到达底部
const REPORT_SUCCESS = 'b_waimai_wi1ikdly_mv'; // 曝光成功
const REPORT_FAILED = 'b_waimai_xracey5g_mv'; // 曝光失败
const API_NOT_SUPPORT = 'b_waimai_pf0ttosd_mv'; // api不支持
const OPEN_NEXT_PAGE = 'b_waimai_bo1y4xig_mv'; // 加载下一页

/**
 * 列表滚动加载
 * @param {object} option
 * @param {function} option.reportObserve 用于曝光的函数,如果不传递此参数表示不启用曝光功能
 * @param {function} option.fetchDataList 列表接口,参数pageNo
 * @param {function} option.renderItem 列表渲染方法
 * @param {string} [option.bottomTipID] 底部提示DOM元素
 * @param {string} [option.listContainerID] 列表容器
 * @param {array} [option.dataList] 列表数据
 * @param {function} [option.afterReport] 曝光后的回调，用于曝光后的特定上报操作
 */
const scrollLoading = function (option = {}) {
    const {
        reportObserve,
        fetchDataList,
        renderItem,
        bottomTipID = 'scroll-loading-bottom-tip',
        listContainerID = 'scroll-loading-list-container',
        dataList = [],
        afterReport,
    } = option;
    const bottomTip = dom.$id(bottomTipID);
    const listContainer = dom.$id(listContainerID);
    const isOpenMonitor = isFunction(reportObserve);

    if (!observerObj[bottomTipID]) {
        observerObj[bottomTipID] = { observer: null, pageNo: 2, isEnd: false };
    }

    const _unMonitorDom = () => {
        if (observerObj[bottomTipID]) {
            if (observerObj[bottomTipID].observer) {
                observerObj[bottomTipID].observer.unobserve(bottomTip);
                observerObj[bottomTipID].observer = null;
            }
            observerObj[bottomTipID].pageNo = 2;
            observerObj[bottomTipID].isEnd = false;
        }
    };
    /**
     * 到达底部，停止分
     */
    const setEnding = () => {
        bottomTip.innerText = '亲，没有更多啦~';
        observerObj[bottomTipID].isEnd = true;
        _unMonitorDom();
        // 上报到达底部
        oadLX.mv(REACH_BOTTOM);
    };

    // 参数检查
    if (!isFunction(fetchDataList)) {
        throw new Error('scrollLoading: the function fetchDataList is required');
    }
    if (!isFunction(renderItem)) {
        throw new Error('scrollLoading: renderItem is required');
    }
    if (!bottomTip || !listContainer) {
        throw new Error('scrollLoading: the bottomTip and listContainer DOM are not obtained');
    }
    if (dataList.length === 0) {
        setEnding();
    }

    // 处理曝光
    const _handleImpMonitor = () => {
        // 所有的店铺dom class
        const poiCards = document.querySelectorAll(`#${listContainerID} [data-monitor-index]`);
        // 未被监控的店铺dom
        const unObservePoiCard = [];

        // 移除所有的监听曝光dom，避免重复监听曝光，每一个店铺只能绑定监听一次
        Array.from(poiCards).forEach((item) => {
            if (!item.getAttribute('on-observe')) {
                unObservePoiCard.push(item);
                item.setAttribute('on-observe', '1');
            }
        });
        if (unObservePoiCard.length) {
            createObserve(async (err, item) => {
                if (err) {
                    return;
                }
                try {
                    const currentIndex = item.target.getAttribute('data-monitor-index');
                    const currentPoiInfo = dataList[currentIndex];

                    if (currentPoiInfo.impMonitorUrl) {
                        await reportObserve(currentPoiInfo.impMonitorUrl);
                        if (isFunction(afterReport)) {
                            afterReport(currentPoiInfo);
                        }
                        // 曝光成功
                        oadLX.mvItem(REPORT_SUCCESS, currentPoiInfo.contentPvId, currentPoiInfo.poi_id_str, currentIndex);
                    }
                } catch (error) {
                    // 曝光失败
                    oadLX.mv(REPORT_FAILED);
                    console.error('曝光错误', error);
                }
            }, unObservePoiCard);
        }
    };

    // 处理DOM
    const _handlePoiDom = async () => {
        const { isEnd, pageNo } = observerObj[bottomTipID];
        if (isEnd) {
            return;
        }
        const domList = [];
        try {
            const curPagePoiList = await fetchDataList(pageNo);
            if (Array.isArray(curPagePoiList) && curPagePoiList.length === 0) {
                setEnding();
            } else {
                const startIndex = dataList.length;
                Array.isArray(curPagePoiList) &&
                    curPagePoiList.forEach((item, index) => {
                        dataList.push(item);
                        domList.push(renderItem(item, startIndex + index));
                    });
            }
            dom.appendDom(listContainer, domList.join(''));
            // 下一页加载成功
            const valLab = { custom: { pageNo } };
            oadLX.mv(OPEN_NEXT_PAGE, valLab);
            isOpenMonitor && _handleImpMonitor();
        } catch (error) {
            console.error(error);
            setEnding();
        }
    };

    /**
     * 滚动加载初始化
     * @param {Object} options IntersectionObserver 生成观察器参数
     */
    const scrollLoadingInit = (options = { threshold: 0 }) => {
        _unMonitorDom();
        // 第一页数据曝光绑定

        isOpenMonitor && _handleImpMonitor();

        if (window.IntersectionObserver) {
            observerObj[bottomTipID].observer = new IntersectionObserver(async (entries) => {
                if (entries[0].isIntersecting) {
                    await _handlePoiDom();
                    observerObj[bottomTipID].pageNo += 1;
                }
            }, options);

            observerObj[bottomTipID].observer.observe(bottomTip);
        } else {
            setEnding();
            // 不支持IntersectionObserver
            oadLX.mv(API_NOT_SUPPORT);
        }
    };

    return {
        scrollLoadingInit,
        setEnding,
    };
};

export default scrollLoading;
